<template>
    <v-snackbar v-model="visible" top :timeout="3000" >
        {{ $page.props.message }}
        <template v-slot:action="{ attrs }">
            <v-btn color="red" text v-bind="attrs" @click="visible = false" class="focus:tw-outline-none">
            Fechar
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
export default {
    data(){
        return{
            visible: false,
        }
    },
    mounted(){
        if(this.$page.props.message){
            this.visible = true;
        }
    },
    watch:{
        '$page.props.message'(newVal, oldVal){
            if(newVal){
                this.visible = true;
            }
        }
    }
}
</script>

<style>

</style>